import { Currency } from './globals/currency'
import { RealStateAddress } from './real-state-address'

export type RealState = Nullable<{
  propertyName: string
  propertyDescription: string
  valuablesDescription: string
  roofType: string
  squareMetersArea: number
  use: PropsTypesOf<typeof RealStateUse>['code']
  buildingType: PropsTypesOf<typeof RealStateBuildingType>['code']
  waterSurfaceDistance: PropsTypesOf<typeof RealStateWaterSurfaceDistance>['code']
  condition: PropsTypesOf<typeof RealStateCondition>['code']
  hasHoses: boolean
  hasFireAlarm: boolean
  hasTheftAlarm: boolean
  hasSteelFence: boolean
}> & {
  propertyValue: Currency
  valuablesValue: Currency
  address: RealStateAddress
}

function load(model?: Partial<RealState> | null): RealState {
  return {
    propertyName: model?.propertyName ?? null,
    propertyDescription: model?.propertyDescription ?? null,
    propertyValue: model?.propertyValue ?? Currency.load(),
    valuablesDescription: model?.valuablesDescription ?? null,
    valuablesValue: model?.valuablesValue ?? Currency.load(),
    roofType: model?.roofType ?? null,
    squareMetersArea: model?.squareMetersArea ?? null,
    use: model?.use ?? null,
    buildingType: model?.buildingType ?? null,
    waterSurfaceDistance: model?.waterSurfaceDistance ?? null,
    condition: model?.condition ?? null,
    hasHoses: model?.hasHoses ?? null,
    hasFireAlarm: model?.hasFireAlarm ?? null,
    hasTheftAlarm: model?.hasTheftAlarm ?? null,
    hasSteelFence: model?.hasSteelFence ?? null,
    address: model?.address ?? RealStateAddress.load(),
  }
}

export const RealStateUse = {
  Residencial: { label: 'Residencial', code: 'Residencial' },
  Business: { label: 'Comercial', code: 'Business' },
  Mixed: { label: 'Mixta', code: 'Mixed' },
} as const

function getUseTypeList() {
  return Object.values(RealStateUse)
}

export const RealStateBuildingType = {
  SuperiorConstruction: { label: 'Construcción Superior', code: 'SuperiorConstruction' },
  Apartments: { label: 'Edificio de Apartamentos', code: 'Apartments' },
  FirstClass: { label: 'Primera Clase', code: 'FirstClass' },
  FirstClassSpecial: { label: 'Primera Clase Especial', code: 'FirstClassSpecial' },
} as const

function getBuildingTypeList() {
  return Object.values(RealStateBuildingType)
}

export const RealStateWaterSurfaceDistance = {
  Close: { label: 'Menos de 200 Mts', code: 'Close' },
  Near: { label: 'Entre 200 y 500 Mts', code: 'Near' },
  Far: { label: 'Mayor de 500 Mts', code: 'Far' },
} as const

function getWaterSurfaceDistanceTypeList() {
  return Object.values(RealStateWaterSurfaceDistance)
}

export const RealStateCondition = {
  New: { label: 'Nuevo', code: 'New' },
  Used: { label: 'Segundo uso', code: 'Used' },
  Renewed: { label: 'Remodelada', code: 'Renewed' },
  InConstruction: { label: 'En construcción', code: 'InConstruction' },
  InBlueprints: { label: 'En planos', code: 'InBlueprints' },
} as const

function getConditionTypeList() {
  return Object.values(RealStateCondition)
}

const map = {
  //toInmuebleViewModel(model: RealState): ArgentoStoresApiSchema<'InmuebleViewModel`1'> {
  //  const requestModel: ArgentoStoresApiSchema<'InmuebleViewModel`1'> = {}
  //  address: Address.map.toAddressModel(model.address),
  //  squareMetersArea: model.squareMetersArea ?? undefined,
  //  condition: model.condition ?? undefined,
  //  waterSurfaceDistance: model.waterSurfaceDistance ?? undefined,
  //  name: model.propertyName,
  //  propertyAmountToInsure: model.propertyValue.value ?? undefined,
  //  propertyAmountToInsureCurrency: model.propertyValue.currency ?? undefined,
  //  propertyDescription: model.propertyDescription,
  //  roofType: model.roofType,
  //  safetyChecks: [],
  //  buildingType: model.buildingType ?? undefined,
  //  use: model.use ?? undefined,
  //  valuableAmountToInsure: model.valuablesValue.value ?? undefined,
  //  valuableAmountToInsureCurrency: model.valuablesValue.currency ?? undefined,
  //  valuableDescription: model.valuablesDescription,
  //}
  //if (model.hasFireAlarm) data.safetyChecks?.push('FireAlarm')
  //if (model.hasTheftAlarm) data.safetyChecks?.push('TheftAlarm')
  //if (model.hasSteelFence) data.safetyChecks?.push('SteelFence')
  //if (model.hasHoses) data.safetyChecks?.push('Hose')
  //  return requestModel
  //},
}

export const RealState = {
  load,
  getUseTypeList,
  getBuildingTypeList,
  distanceToWaterSurfaceTypeList: getWaterSurfaceDistanceTypeList,
  getConditionTypeList,
  map,
}
